<template>
  <el-dialog
    :title="$t('app.details')"
    :visible.sync="dialogVisible"
    width="800px"
  >
    <el-row class="info">
      <el-col :span="12" style="margin-bottom: 15px">{{
        $t("app.room") + ":" + room
      }}</el-col>
      <el-col :span="12" style="margin-bottom: 15px">{{
        $t("app.bed") + ":" + bed
      }}</el-col>
      <el-col :span="12" style="margin-bottom: 15px">
        {{ $t("app.studentNumber") + ":" + studentNumber }}
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px">
        {{ $t("app.gender") + ":" + gender }}
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px; word-break: normal">
        {{ $t("app.nameEnglish") + ":" + nameEnglish }}
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px">
        {{ $t("app.nameChina") + ":" + nameChina }}
      </el-col>
      <el-col :span="24" style="margin-bottom: 15px">{{
        $t("app.contactInformation") + ":" + contactInformation
      }}</el-col>
      <el-col :span="24" style="height: auto">
        {{ $t("app.checkInDate") + ":" }}
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="date"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { checkIn } from "@/api/dormitoryManagement/list";
export default {
  data() {
    return {
      dialogVisible: false,
      studentNumber: "",
      room: "",
      bed: "",
      gender: "",
      nameEnglish: "",
      nameChina: "",
      contactInformation: "",
      date: new Date(),
      loading: false,
    };
  },
  methods: {
    edit(row) {
      this.dialogVisible = true;
      this.studentNumber = row.studentNumber;
      this.room = row.room;
      this.bed = row.bed;
      this.gender = row.gender;
      this.nameEnglish = row.nameEnglish;
      this.nameChina = row.nameChina;
      this.contactInformation = row.contactInformation;
    },
    handleClose() {
      if (!this.date) {
        this.$message({
          message: this.$t("app.validation.date"),
          type: "warning",
        });
        return;
      }
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        this.loading = true;
        checkIn({ StudentCode: this.studentNumber, CheckInDate: this.date })
          .then(() => {
            this.success();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.$emit("checkInSuccess");
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.info .el-col {
  height: 30px;
  line-height: 30px;
}
</style>
